import * as Dialog from '@radix-ui/react-dialog';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const ModalBackdrop = styled(Dialog.Overlay)`
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    background-color: ${theme.colors.background.dimming};
    z-index: ${theme.zIndex.modalBackdrop};
`;
